import * as actionTypes from './ActionTypes'

export const switch_sidebar = () => ({type: actionTypes.SWITCH_SIDEBAR})
export const switch_dark_mode = () => ({type: actionTypes.SWITCH_DARK_MODE})